import React, { PropsWithChildren, ReactElement } from 'react';

export type LogicalConnectionGroupProps = PropsWithChildren<unknown>;

export const LogicalConnectionGroup = ({
  children,
}: LogicalConnectionGroupProps): ReactElement => (
  <g className="logical-connections-group">{children}</g>
);
